export default{
    staffSummary:null,
    staffSummaryAppointment:null,
    staffSummaryAppointmentMeta:null,
    staffSummaryAppointmentCols:null,
    staffSummaryPatient:null,
    staffSummaryPatientCols:null,
    staffSummaryMeta:null,
    visibleModal:false
}